export default "__VITE_ASSET__5ad89468__"